import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { Store } from '@ngrx/store';
import { UserStoreState, UserStoreSelector } from '@nrwl/rx-state-user';
import { filter, map, take } from 'rxjs';
import { Doctor } from '@nrwl/rx-models';

export const currentUserResolver: ResolveFn<Doctor> = () => {
  const store = inject(Store<UserStoreState.UserState>);

  return store.select(UserStoreSelector.getUser).pipe(
    filter((user) => !!user),
    map((user) => new Doctor(user)),
    take(1),
  );
};
